const INGREDIENTS = {
  salad: { label: "Lettuce", price: 0.25 },
  bacon: { label: "Bacon", price: 0.95 },
  cheese: { label: "Cheese", price: 0.45 },
  meat: { label: "Patty", price: 1.5 },
};

export default INGREDIENTS;
